var userAgent = require('../internals/engine-user-agent');

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-ff-version.js
// module id = 1077
// module chunks = 0